import { render, staticRenderFns } from "./VodTestMain.vue?vue&type=template&id=2926aa9c&scoped=true&"
import script from "./VodTestMain.vue?vue&type=script&lang=js&"
export * from "./VodTestMain.vue?vue&type=script&lang=js&"
import style0 from "./VodTestMain.vue?vue&type=style&index=0&id=2926aa9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2926aa9c",
  null
  
)

export default component.exports